import { z } from 'zod';

export interface Certification {
  readonly id: string;
  readonly certifierId: string;
  readonly freelancerId: string;
  readonly note: string | null;
  readonly createdAt: string;
  readonly certifierName: string | null;
}

const rowSchema = z.object({
  id: z.string(),
  certifier_id: z.string(),
  freelancer_id: z.string(),
  note: z.string().nullable(),
  created_at: z.string(),
  certifier: z.object({ full_name: z.string() }).nullable().optional(),
});

export function mapCertification(row: unknown): Certification {
  const r = rowSchema.parse(row);
  return {
    id: r.id,
    certifierId: r.certifier_id,
    freelancerId: r.freelancer_id,
    note: r.note,
    createdAt: r.created_at,
    certifierName: r.certifier?.full_name ?? null,
  };
}
